<template>
  <div :style="column.align?`text-align:${column.align}`:''">{{absence[column.columnName]}}</div>
</template>
<script>

export default {
  name:'TextCell',
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
  },
}
</script>